namespace TabAurous.SalesOrder {
    export namespace OrderStatusService {
        export const baseUrl = 'SalesOrder/OrderStatus';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/OrderStatus/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderStatusService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
